/**
 * Loading overlay Alpine component.
 *
 * Shows a full-page spinner inside the Shadow DOM whenever an HTMX request
 * is triggered from an element carrying the `data-loading-overlay` attribute.
 * Hides automatically on response, error, or network failure.
 *
 * Display is managed directly via style.display to avoid Bootstrap's
 * d-flex { display: flex !important } overriding Alpine x-show.
 *
 * Usage in template:
 *   <div x-data="loadingOverlay()" ...>...</div>
 *
 * Usage on trigger buttons:
 *   <button data-loading-overlay hx-get="...">...</button>
 */
export default () => ({
    _cleanup: null,

    init() {
        const shadowRoot = this.$el.getRootNode();
        const el = this.$el;
        let pendingElt = null;

        const show = () => { el.style.display = 'flex'; };
        const hide = () => { el.style.display = 'none'; };

        const onBefore = (e) => {
            if ('loadingOverlay' in (e.detail?.elt?.dataset ?? {})) {
                pendingElt = e.detail.elt;
                show();
            }
        };

        const onAfter = (e) => {
            if (e.detail.elt === pendingElt) {
                pendingElt = null;
                hide();
            }
        };

        shadowRoot.addEventListener('htmx:beforeRequest', onBefore);
        shadowRoot.addEventListener('htmx:afterRequest', onAfter);
        shadowRoot.addEventListener('htmx:sendError', onAfter);

        this._cleanup = () => {
            shadowRoot.removeEventListener('htmx:beforeRequest', onBefore);
            shadowRoot.removeEventListener('htmx:afterRequest', onAfter);
            shadowRoot.removeEventListener('htmx:sendError', onAfter);
        };
    },

    destroy() {
        this._cleanup?.();
    }
});
